import { render, staticRenderFns } from "./modalSucumbencias.vue?vue&type=template&id=1563c848&scoped=true&"
import script from "./modalSucumbencias.vue?vue&type=script&lang=js&"
export * from "./modalSucumbencias.vue?vue&type=script&lang=js&"
import style0 from "./modalSucumbencias.vue?vue&type=style&index=0&id=1563c848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563c848",
  null
  
)

export default component.exports